import { createRouteToPatientChartPage } from '../../../features/admissions/charts/util';
import { PatientDiagnoses } from '~/features/careplanning/diagnoses/PatientDiagnoses';
import { Section } from '~/shared/section/Section';
import { SectionTitle } from '~/shared/section/SectionTitle';
import { useChart } from '~/features/admissions/charts/ChartContext';
import { CertificationPeriodDischargePlans } from '~/features/discharge/CertificationPeriodDischargePlans';
import { CertificationPeriodPlanOfCare } from '~/features/careplanning/planofcare/CertificationPeriodPlanOfCare';

export function getDiagnosesRoutePath(patientId: string, stayId: string, certificationPeriodId: string) {
	return `${createRouteToPatientChartPage(patientId, stayId, certificationPeriodId)}/plan-of-care/diagnoses`;
}

export function DiagnosesRoute() {
	const { certificationPeriodId } = useChart();
	return (
		<Section header={<SectionTitle title="Diagnoses" />}>
			<PatientDiagnoses certificationPeriodId={certificationPeriodId} />
		</Section>
	);
}

export function DischargePlanRoute() {
	const { certificationPeriodId } = useChart();
	return <CertificationPeriodDischargePlans certificationPeriodId={certificationPeriodId} />;
}

export function PlanOfCareRoute() {
	const { certificationPeriodId } = useChart();
	return <CertificationPeriodPlanOfCare certificationPeriodId={certificationPeriodId} />;
}
